import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Contents, InspectionButton } from '../css/CSS.js';
import { useNavigate } from 'react-router-dom';

import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

export default function InspectionCardMenu() {
    const navigate = useNavigate();

    const cardContent = [
        {
            category: '点検記録',
            contents: [
                {
                    buttonText: '点検記録(短期保証)',
                    buttonVariant: 'contained',
                    link: '/inspection/shorttermWarranty/list',
                    description: [
                        '３ヵ月～２４ヵ月点検',
                    ],
                    iconcolor: '#52B833'
                },
                {
                    buttonText: '点検記録(長期保証)',
                    buttonVariant: 'contained',
                    link: '/inspection/longtermWarranty/list',
                    description: [
                        '４年～１０年点検',
                    ],
                    iconcolor: '#78358B'
                },
                //{
                //    buttonText: '点検記録(ヒュースドクトル50)',
                //    buttonVariant: 'contained',
                //    link: '',
                //    description: [
                //        '１５年～５０年点検',
                //    ],
                //},
            ]
        },
        {
            category: 'その他点検',
            contents: [
                {
                    buttonText: '訪問記録',
                    buttonVariant: 'contained',
                    link: '/inspection/visitReport/customerlist',
                    description: [
                    ],
                    iconcolor: '#52B833'
                },
            ]
        },
        {
            category: '外部請負',
            contents: [
                {
                    buttonText: '外部請負担当物件管理',
                    buttonVariant: 'contained',
                    link: '/inspection/propertyAssignment/list',
                    description: [
                    ],
                    iconcolor: '#52B833'
                },
                {
                    buttonText: '外部請負担当アカウント管理',
                    buttonVariant: 'contained',
                    link: '/inspection/accountManagement/list',
                    description: [
                    ],
                    iconcolor: '#78358B'
                },
            ]
        },
    ]

    const setIcon = (category, iconcolor) => {
        switch (category) {
            case "点検記録":
                return <AssignmentTurnedInIcon style={{ width: "100%", fontSize: 150 }} sx={{ color: iconcolor }} />;
            case "その他点検":
                return <FactCheckIcon style={{ width: "100%", fontSize: 150 }} sx={{ color: iconcolor }} />
            case "外部請負":
                return <ManageAccountsIcon style={{ width: "100%", fontSize: 150 }} sx={{ color: iconcolor }} />
            default:
                return null;
        }
    }
    function buttonOnClick(link) {
        navigate(link)
    }


    React.useLayoutEffect(() => {
        localStorage.removeItem('URLparams')
    }, []);

    return (
        <React.Fragment>
            <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
            <CssBaseline />
            <Grid sx={{ mt: 5, mb: 10 }} />
            <Contents>
                <Grid container alignItems="flex-end" spacing={1}>
                    {cardContent.map((card, contentsIndex) => (
                        card.category === "外部請負" &&
                            (localStorage.getItem("loginType") === "2" || localStorage.getItem("inspectionVendorEdit") === "0") ?
                            null
                            :
                            <Grid key={'Contents' + contentsIndex} container item xs={12} spacing={2} columnSpacing={1} >
                                <Typography sx={{ fontSize: 25, width: '100%' }}>{card.category}</Typography>
                                <Grid container direction="row" spacing={2} sx={{ mb: 5, }} item xs={12}>
                                    {card.contents.map((cardContent, index) => (
                                        <Grid item xs={12} md={4} key={cardContent + index} >
                                            < Grid container
                                                sx={{
                                                    width: "100%",
                                                    justifyContent: "flex-start",
                                                    alignItems: "flex-start",
                                                }}>
                                                <InspectionButton onClick={() => buttonOnClick(cardContent.link)} sx={{ width: "100%" }}>
                                                    <Card sx={{ bgcolor: '#eeeeee', width: "100%" }}>
                                                        {setIcon(card.category, card.contents[index].iconcolor)}
                                                        <CardContent sx={{ bgcolor: '#289bdf', height: 130 }}>
                                                            <Typography gutterBottom sx={{ color: '#ffffff', fontSize: 20 }}>
                                                                {cardContent.buttonText}
                                                            </Typography>
                                                            <CardContent>
                                                                <ul>
                                                                    {cardContent.description.map((description, listIndex) => (
                                                                        <Typography sx={{ color: '#eeeeee', fontSize: 16 }} key={cardContent.buttonText + listIndex}>
                                                                            {description}
                                                                        </Typography>
                                                                    ))}
                                                                </ul>
                                                            </CardContent>
                                                        </CardContent>
                                                    </Card>
                                                </InspectionButton>
                                            </Grid>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                    ))}
                </Grid>
            </Contents>
        </React.Fragment>
    );
}